import { useDataChange, useDataValue } from 'Simple/Data.js'
import produce from 'immer'

export function useOnChange(props) {
  let patientAddress = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'answers.patientAddress.answer',
  })

  let question = useDataValue({
    viewPath: props.viewPath,
    context: 'question',
  })

  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'question',
    path: 'answer',
  })

  return function onChange(value) {
    let { answer } = question || {}

    let address = patientAddress

    let nextAnswer = produce(answer, next => {
      next.street.answer =
        value && address.street !== null && address.street !== undefined
          ? address.street.answer
          : ''
      next.city.answer =
        value && address.city !== null && address.city !== undefined
          ? address.city.answer
          : ''
      next.state.answer =
        value && address.state !== null && address.state !== undefined
          ? address.state.answer
          : ''
      next.zip.answer =
        value && address.zip !== null && address.zip !== undefined
          ? address.zip.answer
          : ''
      next.usePatient.answer = value
    })

    change(nextAnswer)
  }
}
